import { render, staticRenderFns } from "./SiteBlock.vue?vue&type=template&id=06379cb6&scoped=true&"
import script from "./SiteBlock.vue?vue&type=script&lang=js&"
export * from "./SiteBlock.vue?vue&type=script&lang=js&"
import style1 from "./SiteBlock.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06379cb6",
  null
  
)

export default component.exports